<template>
  <label class="tag" :class="typo" @click.stop="selectMe">
    <div class="tag-title">{{ item.name }}</div>
    <div class="tag-close" v-if="removable" @click.stop="removeMe">
      <i class="icon icon-cancel"></i>
    </div>
  </label>
</template>

<script>
export default {
  name: "Tag",
  props: {
    item: Object,
    typo: {
      type: String,
      default: "typo-paragraph10 typo-regular"
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    selectMe() {
      this.$emit("select", this.item);
    },
    removeMe() {
      this.$emit("remove", this.item);
    }
  }
};
</script>

<style lang="scss" scoped>
.tag {
  @include flex-center;

  text-align: center;
  align-self: flex-end;
  box-sizing: border-box;
  border-radius: $radius;
  
  cursor: pointer;
  color: $textLightModeDisabled;
  border: 1px solid $textDarkModeLow;
  @include trans-all;
  user-select: none;

  &-title {
    padding: 3px 6px;
    text-align: right;
  }

  &-close {
    background: $textLightModeDisabled;
    color: #fff;
    min-height: 17px;
    padding: 3px;
    @include flex-center;
  }

  &:hover {
    color: $textDarkModeDisabled;
    border-color: $textDarkModeDisabled;
  }

  &:hover &-close {
    background: $textDarkModeDisabled;
  }

  &:not(:first-child) {
    margin-top: 4px;
  }
}
</style>
